import { gql } from "@apollo/client";

export const getTransferPhoneNumbers = gql`
    query GetTransferPhoneNumbers($queryParams: QueryParams) {
        getTransferPhoneNumbers(queryParams: $queryParams, isManagerContext: true) {
            id
            name
            phoneNumber
            integration
            profileAttributes
            externalId
            sipUri
            profileAttributesMap
            sipHeadersMap
            uuiHeadersMap
            teams {
                id
                name
            }
            attributes {
                sipMethod
                endRecordingOnTransfer
                five9 {
                    routeType
                    routeValue
                    routeReason
                    additionalMetadata
                }
            }
            createdBy
            createdAt
            createdBy
            updatedAt
            updatedBy
            contactAttribute
            isDynamicTransfer
        }
    }
`;

export const getTransferPhoneNumbersForTeams = gql`
    query GetTransferPhoneNumbers($queryParams: QueryParams) {
        getTransferPhoneNumbers(queryParams: $queryParams) {
            id
            name
            phoneNumber
            integration
            profileAttributes
            externalId
            sipUri
            profileAttributesMap
            sipHeadersMap
            uuiHeadersMap
            attributes {
                sipMethod
                endRecordingOnTransfer
                five9 {
                    routeType
                    routeValue
                    routeReason
                    additionalMetadata
                }
            }
            contactAttribute
            isDynamicTransfer
        }
    }
`;
